<div class="drawer-container">
    @if (open()) {
        <div
            role="presentation"
            @fadeInAnimation
            (click)="close()"
            class="drawer-container__back-drop"
        ></div>

        @switch (item.options.position) {
            @case ('right') {
                <div @slideInAnimationRight class="drawer-container__panel right-0">
                    <ng-container #container />
                </div>
            }
            @case ('left') {
                <div @slideInAnimationLeft class="drawer-container__panel left-0">
                    <ng-container #container />
                </div>
            }
        }
    }
</div>
